import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabase';
import './TransporterLogin.css';

function TransporterLogin() {
  const navigate = useNavigate();
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginForm(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear errors when user starts typing
    if (error) setError('');
    if (name === 'email' && emailError) setEmailError('');
    if (name === 'password' && passwordError) setPasswordError('');
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailBlur = () => {
    if (loginForm.email && !validateEmail(loginForm.email)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };

  const handlePasswordBlur = () => {
    // No password length restriction
    setPasswordError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // Check if transporter exists in transport_persons table
      const { data: transporterData, error: transporterError } = await supabase
        .from('transport_persons')
        .select('*')
        .eq('email', loginForm.email)
        .single();

      if (transporterError || !transporterData) {
        setError('Invalid email or password. Please try again.');
        return;
      }

      // For demo purposes, we'll accept any password for existing transporters
      // In a real app, you'd verify the password against a hash
      // No password length restriction

      // Store transporter data in localStorage
      localStorage.setItem('transporterData', JSON.stringify(transporterData));
      
      // Navigate to transporter dashboard
      navigate('/transporter/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred during login. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="transporter-login-container">
      <main className="transporter-login-main">
        <div className="transporter-login-card">
          <div className="transporter-login-form-container">
            <img 
              src="https://gjamvfwvqlizginqdfhd.supabase.co/storage/v1/object/public/transport-uploads/WhatsApp%20Image%202025-11-21%20at%2011.57.28%20AM%20(1).jpeg" 
              alt="Nexy App Logo" 
              className="transporter-login-logo"
            />
            
            <h2>Login As Transporter</h2>
            <p className="form-subtitle">Access your transport management portal</p>
            
            {error && <div className="error-message">{error}</div>}
            
            <form className="transporter-login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={loginForm.email}
                  onChange={handleInputChange}
                  onBlur={handleEmailBlur}
                  placeholder="Enter your email"
                  className={emailError || error ? 'error' : ''}
                  required
                  disabled={isLoading}
                />
                {emailError && <span className="error-text">{emailError}</span>}
              </div>
              
              <div className="form-group">
                <label htmlFor="password">Password</label>
                  <input
                  type="password"
                    id="password"
                    name="password"
                    value={loginForm.password}
                    onChange={handleInputChange}
                    onBlur={handlePasswordBlur}
                    placeholder="Enter your password"
                    className={passwordError || error ? 'error' : ''}
                    required
                    disabled={isLoading}
                  />
                {passwordError && <span className="error-text">{passwordError}</span>}
              </div>
              
              <div className="remember-me-container">
                <label className="remember-me-label">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="remember-me-checkbox"
                  />
                  <span className="remember-me-text">Remember me</span>
                </label>
              </div>
              
              <button 
                type="submit" 
                className="transporter-login-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <svg className="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeDasharray="32" strokeDashoffset="32">
                        <animate attributeName="stroke-dasharray" dur="2s" values="0 32;16 16;0 32;0 32" repeatCount="indefinite"/>
                        <animate attributeName="stroke-dashoffset" dur="2s" values="0;-16;-32;-32" repeatCount="indefinite"/>
                      </circle>
                    </svg>
                    Logging in...
                  </>
                ) : 'Login as Transporter'}
              </button>
            </form>
            
            <a href="/" className="back-to-login-link">← Back to main login</a>
          </div>
        </div>
      </main>
    </div>
  );
}

export default TransporterLogin;
